import LegalLayout, { Section } from "../LegalLayout";
import { BUSINESS } from "../businessInfo";

export default function ContactPage() {
  return (
    <LegalLayout
      title="Contact Us"
      showUpdated={false}
      intro={<p>We'd love to hear from you. Reach the {BUSINESS.brandName} team using the details below.</p>}
    >
      <Section heading="Business details">
        <ul className="space-y-2">
          <li><strong>Legal entity:</strong> {BUSINESS.legalName}</li>
          {BUSINESS.address && <li><strong>Registered address:</strong> {BUSINESS.address}</li>}
          <li>
            <strong>Email:</strong>{" "}
            <a className="text-primary-600 hover:text-primary-700" href={`mailto:${BUSINESS.supportEmail}`}>
              {BUSINESS.supportEmail}
            </a>
          </li>
          <li>
            <strong>Phone:</strong>{" "}
            <a className="text-primary-600 hover:text-primary-700" href={`tel:${BUSINESS.supportPhone.replace(/\s+/g, "")}`}>
              {BUSINESS.supportPhone}
            </a>
          </li>
          <li><strong>Support hours:</strong> {BUSINESS.supportHours}</li>
          <li><strong>GSTIN:</strong> {BUSINESS.gstin}</li>
        </ul>
      </Section>

      <Section heading="Support & billing">
        <p>
          For account, billing, or technical help, email{" "}
          <a className="text-primary-600 hover:text-primary-700" href={`mailto:${BUSINESS.supportEmail}`}>
            {BUSINESS.supportEmail}
          </a>. We aim to respond within 2 business days.
        </p>
      </Section>

      <Section heading="Policies">
        <p>
          See our{" "}
          <a className="text-primary-600 hover:text-primary-700" href="/terms">Terms &amp; Conditions</a>,{" "}
          <a className="text-primary-600 hover:text-primary-700" href="/privacy-policy">Privacy Policy</a>,{" "}
          <a className="text-primary-600 hover:text-primary-700" href="/refund-policy">Refund &amp; Cancellation Policy</a>, and{" "}
          <a className="text-primary-600 hover:text-primary-700" href="/shipping-policy">Shipping &amp; Service Delivery Policy</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
